/* ========================================================================
   Umbraco Forms
 ========================================================================== */

app.umbracoForms = (function () {
  'use strict';

  let loggedError = false;

  function init() {
    const forms = document.querySelectorAll('.umbraco-forms-form');

    forms.forEach((form) => {
      const submitButtons = form.querySelectorAll('button[type="submit"]');

      form.addEventListener('submit', (event) => {
        LoadingOverlay('body');
      });

      submitButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          if (loggedError) return;

          window.setTimeout(function () {
            const formErrors = form.querySelectorAll('.field-validation-error');

            if (formErrors.length > 0) {
              // DATALAYER
              app.dataLayer.pushEvent('formError', {
                pageUrl: window.location.pathname,
                errorMessage: formErrors[0].innerText,
              });

              loggedError = true;
            }
          }, 250);
        });
      });

      if (form.classList.contains('js-quote-form')) {
        initQuoteForm(form);
      }
    });

    const captchaErrors = document.querySelectorAll(
      '.umbraco-forms-form .ucaptcha .field-validation-error'
    );
    if (captchaErrors.length > 0) {
      // DATALAYER
      app.dataLayer.pushEvent('formError', {
        pageUrl: window.location.pathname,
        errorMessage: captchaErrors[0].innerText,
      });
    }
  }

  function initQuoteForm(form) {
    window.dictionary = window.dictionary || {};

    const textArea = form.querySelector(
      '.formslabelsadditionalproducts textarea'
    );

    const buttonContainer = document.createElement('div');
    buttonContainer.classList.add('mt-2');

    const button = document.createElement('a');
    button.classList.add('button');
    button.innerText = window.dictionary['Forms.Buttons.AddProduct'];

    button.addEventListener('click', (event) => {
      event.preventDefault();
      addProduct(form, textArea);
    });

    buttonContainer.appendChild(button);
    textArea.after(buttonContainer);
  }

  function addProduct(form, textArea) {
    let textArray = [];
    const fields = form.querySelectorAll('.umbraco-forms-field');

    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      if (field.classList.contains('formslabelsadditionalproducts')) break;

      const label = field.querySelector('.umbraco-forms-label');
      if (label) textArray.push(label.innerText.replace('*', '').trim() + ':');
    }

    if (textArea.value.length > 0) {
      textArea.value += '\n\n';
    }

    textArea.value += textArray.join('\n');
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();

app.umbracoForms.init();
